import React, { Fragment, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { GET_ONE, provider } from '../../_utils';
import { Labeled, TextField, DateField, SelectField, Row, CloseButton } from '../index';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Опции для селектов (соответствуют operators/components/utils.js)
const statuses = [
    { id: 'Active', name: 'Активен' },
    { id: 'Terminated', name: 'Уволен' }
];

const operatorsTypes = [
    { id: 'operator', name: 'Оператор' },
    { id: 'leader', name: 'Супервизор' },
    { id: 'staf', name: 'Администрация' },
    { id: 'senior', name: 'Старший' },
    { id: 'test', name: 'Обучение' }
];

const departments = [
    { id: 'Inbound', name: 'Входящие' },
    { id: 'Outstaffing', name: 'Аутстафинг' },
    { id: 'Outbound', name: 'Исходящие' },
    { id: 'Finance', name: 'Финансы' },
    { id: 'Administaration', name: 'Администрация' }
];

const places = [
    { id: 'minsk', name: 'Минск' },
    { id: 'dabrabyt', name: 'Банк "Дабрабыт"' }
];

const contractTypes = [
    { id: 'Agreement', name: 'Подряд' },
    { id: 'Contract', name: 'Контракт' }
];

const OperatorData = ({ data }) => (
    <Fragment>
        <Box sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                {data && data.login} {data && data.fullname}
            </Typography>
        </Box>
        
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, mt: 2 }}>Персональные данные</Typography>
        {data &&
            <Row>
                <Labeled label="Тел. моб" style={{width: 200}}>
                    <TextField value={data.contact && data.contact.phone ? data.contact.phone.mobile : null}/>
                </Labeled>
                <Labeled label="Тел. др." style={{width: 200}}>
                    <TextField value={data.contact && data.contact.mobile2 ? data.contact.phone.mobile2 : null}/>
                </Labeled>
                <Labeled label="Тел. дом" style={{width: 200}}>
                    <TextField value={data.contact && data.contact.home ? data.contact.phone.home : null}/>
                </Labeled>
                <Labeled label="E-mail" style={{width: 250}}>
                    <TextField value={data.contact && data.contact.email ? data.contact.email : null}/>
                </Labeled>
            </Row>
        }
        
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, mt: 2 }}>Операторские данные</Typography>
        {data &&
            <Row>
                <Labeled label="Статус" style={{width: 200}}>
                    <SelectField options={statuses} value={data.status}/>
                </Labeled>
                <Labeled label="Тип" style={{width: 200}}>
                    <SelectField options={operatorsTypes} value={data.type}/>
                </Labeled>
                <Labeled label="Отдел" style={{width: 200}}>
                    <SelectField options={departments} value={data.department}/>
                </Labeled>
                <Labeled label="Площадка" style={{width: 200}}>
                    <SelectField options={places} value={data.place}/>
                </Labeled>
            </Row>
        }
        
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, mt: 2 }}>Контракт</Typography>
        {data &&
            <Fragment>
                <Row>
                    <Labeled label="Тип" style={{width: 250}}>
                        <SelectField options={contractTypes} value={data.contract ? data.contract.type : null}/>
                    </Labeled>
                    <Labeled label="Номер" style={{width: 250}}>
                        <TextField value={data.contract ? data.contract.no : null}/>
                    </Labeled>
                    <Labeled label="От" style={{width: 200}}>
                        <DateField value={data.contract ? data.contract.entered : null}/>
                    </Labeled>
                    <Labeled label="До" style={{width: 200}}>
                        <DateField value={data.contract ? data.contract.termitated : null}/>
                    </Labeled>
                </Row>
            </Fragment>
        }
    </Fragment>
);

const OperatorInfoModal = ({ open, onClose, operatorId }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open && operatorId) {
            const fetchOperatorData = async () => {
                setLoading(true);
                setError(null);
                try {
                    const { data: operatorData, status } = await provider(
                        GET_ONE,
                        '/operators',
                        operatorId
                    );
                    if (status === 200) {
                        setData(operatorData);
                    } else {
                        setError('Не удалось загрузить данные оператора');
                    }
                } catch (err) {
                    console.error('Error fetching operator data:', err);
                    setError('Ошибка при загрузке данных оператора');
                } finally {
                    setLoading(false);
                }
            };

            fetchOperatorData();
        } else {
            // Сбрасываем данные при закрытии
            setData(null);
            setError(null);
        }
    }, [open, operatorId]);

    const handleClose = () => {
        setData(null);
        setError(null);
        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Информация об операторе
            </DialogTitle>
            <DialogContent>
                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                        <CircularProgress />
                    </Box>
                )}
                {error && (
                    <Box sx={{ p: 2 }}>
                        <Typography color="error">{error}</Typography>
                    </Box>
                )}
                {!loading && !error && data && (
                    <OperatorData data={data} />
                )}
            </DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                <CloseButton handleCloseClick={handleClose} label="Закрыть" />
            </Box>
        </Dialog>
    );
};

export default OperatorInfoModal;

